import React from 'react'

import SEO from 'components/SEO'
import Main from 'components/Main'
import Header from './Header'
import Footer from './Footer'

import 'assets/css/swiper.min.css'
import '@fortawesome/fontawesome-svg-core/styles.css'
import 'react-responsive-modal/styles.css'

export default function Layout({ children, pageTitle, pageDescription, ogImage, header, footer, postData, lang }) {
   return (
      <React.Fragment>
         <SEO pageTitle={pageTitle} pageDescription={pageDescription} ogImage={ogImage} lang={lang} />

         <React.Fragment>
            <Header {...header} postData={postData} />

            <Main>{children}</Main>

            <Footer {...footer} />
         </React.Fragment>
      </React.Fragment>
   )
}
